import React from "react";
import styles from "./styles.module.scss";

export default function LoadingModal() {
    return (
        <div className={ styles.modal }>
            <div className={ styles.spinner } />
        </div>
    );
}
